
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93rDUjTNgLIZGlnSULDzSteCv88JtxN5p7MdQXFQ4w1j4Meta } from "D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/pages/[...slug].vue?macro=true";
export default [
  {
    name: "slug___de",
    path: "/de/:slug(.*)*/",
    meta: _91_46_46_46slug_93rDUjTNgLIZGlnSULDzSteCv88JtxN5p7MdQXFQ4w1j4Meta || {},
    component: () => import("D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*/",
    meta: _91_46_46_46slug_93rDUjTNgLIZGlnSULDzSteCv88JtxN5p7MdQXFQ4w1j4Meta || {},
    component: () => import("D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/pages/[...slug].vue")
  }
]